import { Button } from "antd";
import React, { useState } from "react";
import { AiOutlineMail } from "react-icons/ai";
import { BsFillTelephoneFill } from "react-icons/bs";
import { FiGithub, FiInstagram, FiLinkedin, FiTwitter } from "react-icons/fi";
import { motion } from "framer-motion";
import TextSpan from "../TextSpan/TextSpan";
import ContactModal from "./ContactModal";

const buttonVariants = {
  hover: {
    scale: 1.1,
    textShadow: "0px 0px 8px rgb(255,255,255)",
    boxShadow: "0px 0px 8px rgb(255,255,255)",
    transition: {
      duration: 0.3,
      yoyo: 5,
    },
  },
};

const sentence = "Get In Touch".split("");

export const Contact = () => {
  const [modalVisible, setModalVisible] = useState(false);
  return (
    <div
      name="contact"
      className=" flex justify-center items-center h-[500px] md:h-screen md:p-0 p-3"
    >
      <ContactModal
        visible={modalVisible}
        setVisible={setModalVisible}
      ></ContactModal>
      <div className=" md:w-1/2 w-full flex flex-col gap-6 md:mt-[-90px] justify-center items-center">
        <h1 className="text-green-300 md:text-2xl text-xl">What’s Next?</h1>
        {/* <h1 className="md:text-7xl text-4xl text-white">Get In Touch</h1> */}
        <div>
          {sentence.map((letter, index) => {
            return (
              <TextSpan key={index}>
                {letter === " " ? "\u00A0" : letter}
              </TextSpan>
            );
          })}
        </div>
        <h1 className="text-md text-gray-500 text-center">
          I’m currently looking for any new opportunities, my inbox is always
          open. Whether you have a question or just want to say hi, I’ll try my
          best to get back to you!
        </h1>
        {/* <Button className="border-2 border-green-600 w-32 p-7 mt-10 flex items-center justify-center">
          Say Hello
        </Button> */}
        <div className="flex flex-col md:flex-row justify-between gap-8">
          <motion.div
            variants={buttonVariants}
            onClick={() => setModalVisible(true)}
            whileHover="hover"
            className=" w-full md:w-1/2 flex gap-2 border-2 justify-center items-center border-green-500 p-4 rounded-lg hover:cursor-pointer"
          >
            <AiOutlineMail className="text-green-500 w-8 h-8"></AiOutlineMail>
            <h1 className="text-green-500">assegidassefa7@gmail.com</h1>
          </motion.div>

          <motion.div
            variants={buttonVariants}
            whileHover="hover"
            className="w-full md:w-1/2 flex gap-2 border-2 justify-start items-center border-green-500 p-4 rounded-lg hover:cursor-pointer"
          >
            <BsFillTelephoneFill className="text-green-500 w-8 h-8"></BsFillTelephoneFill>
            <h1 className="text-green-500">+251 938 077 350</h1>
          </motion.div>
          <div className="w-full flex items-start justify-center md:hidden">
            <ol className=" font-mono text-sm flex  text-[#ccd6f6]  gap-7 items-start justify-around w-56">
              <li>
                <FiGithub size={20} />
              </li>
              <li>
                <FiInstagram size={20} />
              </li>
              <li>
                <FiLinkedin size={20} />
              </li>
              <li>
                <FiTwitter size={20} />
              </li>
            </ol>
          </div>
        </div>
      </div>
    </div>
  );
};
